"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get the login URL
 * @param path the path to redirect to once successfully authenticated. Defaults to "/"
 * @return the URL for the login page
 */
const getLoginUrl = (redirectPath = "/") => `/session/sign_in?redirect=${encodeURIComponent(redirectPath)}`;
exports.default = getLoginUrl;
//# sourceMappingURL=getLoginUrl.js.map